import { dataUnderline } from 'dls-icons-data'
import { createIcon } from '../common'

const IconUnderline = /*#__PURE__*/createIcon(dataUnderline)
export default IconUnderline
